/**
 * Enumeration of characters that will not be chosen as the location for inserting line breaks.
 *
 * @export
 * @enum {number}
 */
export var NonBreakingCharEnum;
(function (NonBreakingCharEnum) {
    NonBreakingCharEnum["space"] = "\u00A0";
    NonBreakingCharEnum["narrowSpace"] = "\u202F";
    NonBreakingCharEnum["hyphen"] = "\u2011";
    NonBreakingCharEnum["empty"] = "";
})(NonBreakingCharEnum || (NonBreakingCharEnum = {}));
/**
 * Enumeration of special characters
 *
 * @export
 * @enum {number}
 */
export var SpecialCharEnum;
(function (SpecialCharEnum) {
    SpecialCharEnum["maskedChar"] = "\u2055";
})(SpecialCharEnum || (SpecialCharEnum = {}));
/**
 * Return a masked version of the input string
 *
 * @export
 * @param {string} template
 * @return {*}  {string}
 */
export function maskString(template, maskingChar = SpecialCharEnum.maskedChar) {
    return template.replace(/[^\s]/gsiu, maskingChar);
}
//# sourceMappingURL=characters.js.map